import { Injectable } from '@angular/core';
import {
  IVerifoneCancelRequest,
  IVerifonePairRequest,
  IVerifonePairResponse,
  IVerifonePurchaseRequest,
  IVerifoneRefundRequest,
  IVerifoneTransactionResponse,
} from '@principle-theorem/principle-core/interfaces';
import {
  getError,
  httpsCallable,
  SerialisedData,
  serialise,
  snapshot,
} from '@principle-theorem/shared';

@Injectable()
export class VerifoneService {
  async purchase(
    request: IVerifonePurchaseRequest
  ): Promise<IVerifoneTransactionResponse> {
    return this._callFunction<
      IVerifonePurchaseRequest,
      IVerifoneTransactionResponse
    >('http-verifone-purchase', request, 'Verifone purchase failed');
  }

  async refund(
    request: IVerifoneRefundRequest
  ): Promise<IVerifoneTransactionResponse> {
    return this._callFunction<
      IVerifoneRefundRequest,
      IVerifoneTransactionResponse
    >('http-verifone-refund', request, 'Verifone refund failed');
  }

  async cancel(request: IVerifoneCancelRequest): Promise<void> {
    return this._callFunction<IVerifoneCancelRequest, void>(
      'http-verifone-cancel',
      request,
      'Verifone cancel failed'
    );
  }

  async pairTerminal(
    request: IVerifonePairRequest
  ): Promise<IVerifonePairResponse> {
    return this._callFunction<IVerifonePairRequest, IVerifonePairResponse>(
      'http-verifone-pairTerminal',
      request,
      'Verifone terminal pairing failed'
    );
  }

  private async _callFunction<TReq, TRes>(
    name: string,
    request: TReq,
    errorContext: string
  ): Promise<TRes> {
    try {
      return await snapshot(
        httpsCallable<SerialisedData<TReq>, TRes>(name, { timeout: 120_000 })(
          serialise(request)
        )
      );
    } catch (error) {
      throw new Error(`${errorContext}: ${getError(error)}`);
    }
  }
}
